import { Configuration, LogLevel } from '@azure/msal-browser';

// Azure AD B2C configuration
export const msalConfig: Configuration = {
  auth: {
    clientId: import.meta.env.VITE_AZURE_CLIENT_ID || 'local-development-client-id',
    authority: import.meta.env.VITE_AZURE_AUTHORITY || 'https://login.microsoftonline.com/common',
    knownAuthorities: [import.meta.env.VITE_AZURE_KNOWN_AUTHORITY || 'login.microsoftonline.com'],
    redirectUri: import.meta.env.VITE_REDIRECT_URI || 'http://localhost:3000',
    postLogoutRedirectUri: import.meta.env.VITE_POST_LOGOUT_REDIRECT_URI || 'http://localhost:3000',
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
        }
      },
    },
  },
};

// Scopes for API access
export const loginRequest = {
  scopes: ['openid', 'profile', 'offline_access'],
};

// Scopes for accessing the backend API
export const apiRequest = {
  scopes: [import.meta.env.VITE_API_SCOPE || 'api://b61bfb94-2a9e-46de-8d3f-0dd9f3c99dbe/Customer.Access'],
};
